import Loadable from "react-loadable";
import { EmptyComponent } from "../common/EmptyComponent.js";
import { ClientProviderEnum } from "../../constants/index.js";

export const OddsMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "odds/mobile/odds" */
      "./Odds.mobile.js"
    ),
  loading: EmptyComponent
});

export const OddsPC = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "odds/pc/odds" */
      "./Odds.pc.js"
    ),
  loading: EmptyComponent
});

export const preload = ({ isPC, clientProvider }) => {
  if (clientProvider === ClientProviderEnum.Spectate) {
    if (isPC) OddsPC.preload();
    else OddsMobile.preload();
  }
};
